<script setup lang="ts">
import { defineProps } from 'vue';
import { SubscriptionPeriod, SubscriptionType } from '@/dashboard/types/subscription';
import BasicMoonIcon from '@/dashboard/vue/components/icons/BasicMoonIcon.vue';
import BasicTextIcon from '@/dashboard/vue/components/icons/BasicTextIcon.vue';
import ProTextIcon from '@/dashboard/vue/components/icons/ProTextIcon.vue';
import Divider from '@/dashboard/vue/components/common/Divider.vue';
import ProMoonIcon from '@/dashboard/vue/components/icons/ProMoonIcon.vue';
import { SubscriptionBase } from '@/dashboard/types/subscriptionBase';
import { Price } from '@/dashboard/types/price';

const props = defineProps<{
  type: SubscriptionType;
  period: SubscriptionPeriod;
  prices: Price[];
  selectedPlan?: SubscriptionBase;
}>();

function priceTitle(): string {
  const price = props.prices.find((item) => item.id === props.selectedPlan?.id)?.amount ?? 0;
  const dividedPrice = +price / 12;
  const period = props.period;
  return `$${period === 'year' ? dividedPrice.toFixed(2) : (+price).toFixed(2)} user/month`;
}
</script>

<template>
  <div class="px-l pt-[31px]">
    <div class="flex justify-between">
      <div class="relative flex flex-col items-start gap-s">
        <div class="relative">
          <BasicTextIcon v-if="props.type === 'basic'" class="fill-brand-night-blue" />
          <ProTextIcon v-else-if="props.type === 'pro'" class="fill-brand-night-blue" />

          <span v-if="props.period == 'year'" class="absolute right-[-73px] top-[3px] text-[13px] text-brand-night-blue">Annually</span>
        </div>

        <span v-if="props.type === 'basic'" class="text-content-l">Free forever</span>
        <span v-else class="text-content-l">{{ priceTitle() }}</span>
      </div>

      <BasicMoonIcon v-if="props.type === 'basic'" class="relative right-xs top-xs h-[72px] w-[72px] stroke-brand-night-blue" />
      <ProMoonIcon v-else-if="props.type === 'pro'" class="relative right-xs top-xs h-[72px] w-[72px] stroke-brand-night-blue" />
    </div>

    <Divider class="divider-gray-450 dark:divider-gray-750 mb-[23px] mt-[32px]" />
  </div>
</template>
